import { render, staticRenderFns } from "./LottoResultTable.vue?vue&type=template&id=ebb4c4ec&"
import script from "./LottoResultTable.vue?vue&type=script&lang=js&"
export * from "./LottoResultTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports